<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <!-- alert & button create -->
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <!-- refactorizar condicionales de modulos -->
        <!-- v-if="componenteEvento.agregar_submodulo"  -->
        <ButtonComp normalButton @click="create()" :disabled="!RegAnecdoticoAvailablePerfils"
          textButton="Crear registro anecdótico" iconBut="fas fa-plus" />
      </v-col>
      <v-col cols="12" md="4">
        <AutocompleteComp @change="getAllGradosAdmin(filter.id_nivel, true)" :items="NivelesAdmin"
          v-model="filter.id_nivel" item-text="desc_nivel" item-value="id_nivel_adm_nivel" textLabel="Nivel" />
      </v-col>
      <v-col cols="12" md="4">
        <AutocompleteComp @change="getAllSeccionesGrados(filter.id_grado, true)" :items="filter.GradosAdmin"
          v-model="filter.id_grado" item-text="desc_grado" item-value="id" textLabel="Grado" />
      </v-col>
      <v-col cols="12" md="4">
        <AutocompleteComp @change="seccion_filter()" :items="filter.SeccionGrado" v-model="filter.id_seccion"
          item-text="nombre_seccion" item-value="id" textLabel="Sección" />
      </v-col>
    </v-row>

    <!-- filter table optiosn -->
    <v-row>
      <v-col cols="12">
        <ComundataTablecomp whitSearch :headers="RegistoAnecdoticoHeaders" :items="desserts">

          <template v-slot:hora="{ item }">
            <span>{{ item.hora | filtroFormatoHora }}</span>
          </template>
          <template v-slot:action="{ item }">
            <div class="d-flex gap-10px">
              <ButtonComp verButton tooltipText="Ver anécdota" @click="viewDetail(item)" />
              <!-- refactorizar permisos de modulos -->
              <!-- v-if="componenteEvento.editar_submodulo"  -->
              <ButtonComp editButton tooltipText="Editar anécdota" @click="udpateAnecdotico(item)"
                :disabled="!RegAnecdoticoAvailablePerfils" />
              <ButtonComp listButton @click="active_history(item)" tooltipText="Ver historial" />
              <!-- refactorizar permisos de modulos -->
              <!-- v-if="componenteEvento.borrar_submodulo" -->
              <ButtonComp :disabled="!RegAnecdoticoAvailablePerfils" @click="dialog_delete(item)"
                tooltipText="Eliminar anécdota" deleteButton />
            </div>
          </template>
        </ComundataTablecomp>

      </v-col>

    </v-row>

    <!-- modal create y update -->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="dialog" maxWidth="1000" :title="setreg.title" @close-modal="dialog = false">
        <template v-slot:body>
          <v-row>
            <v-col cols="4">
              <AutocompleteComp @change="getAllGradosAdmin(setreg.id_nivel)" :items="NivelesAdmin"
                v-model="setreg.id_nivel" item-text="desc_nivel" item-value="id_nivel_adm_nivel" textLabel="Nivel"
                :isDisable="setreg.id != 0" :rules="[rules.selectReq]" />
            </v-col>

            <v-col cols="4">
              <AutocompleteComp @change="getAllSeccionesGrados(setreg.id_grado)" :items="GradosAdmin"
                v-model="setreg.id_grado" item-text="desc_grado" item-value="id" textLabel="Grado"
                :isDisable="setreg.id != 0" :rules="[rules.selectReq]" />
            </v-col>

            <v-col cols="4">
              <AutocompleteComp @change="alumnos(setreg.id_seccion)" :items="SeccionGrado" v-model="setreg.id_seccion"
                item-text="nombre_seccion" item-value="id" textLabel="Sección" :isDisable="setreg.id != 0"
                :rules="[rules.selectReq]" />
            </v-col>
            <v-col cols="4">
              <textfieldComp textLabel="Docente" item-text="desc_docente" v-model="setreg.docente" disabled />
            </v-col>

            <v-col cols="8">
              <AutocompleteComp :items="Alumnos" v-model="setreg.id_alumno" item-text="nombre_persona" item-value="id"
                textLabel="Estudiante" :isDisable="setreg.id != 0" :rules="[rules.selectReq]" />
            </v-col>

            <!-- date picker -->
            <v-col cols="4">
              <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted2" label="Fecha" readonly v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker :allowed-dates="allowedDays" v-model="setreg.fecha_evento" no-title
                  @input="menu = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="4">
              <v-text-field ref="refHoraInicio" v-model="setreg.hora_evento" label="Hora de inicio" type="time"
                min="00:01" max="23:59" step="600"></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field label="Lugar de suceso" maxlength="80" v-model="setreg.lugar_evento" required
                :rules="[rules.required]"></v-text-field>
            </v-col>

            <!-- -->
            <v-col cols="6">
              <v-textarea outlined name="input-7-4" label="Descripción / Comentario" v-model="setreg.descripcion_evento"
                rows="3" :rules="[rules.required]">
              </v-textarea>
            </v-col>

            <v-col cols="6">
              <v-textarea outlined name="input-7-4" label="Análisis / Interpretación" v-model="setreg.analisis_evento"
                rows="3">
              </v-textarea>
            </v-col>

            <v-col cols="12">
              <v-row class="d-flex justify-space-between">
                <v-col sm="12" md="4">
                  <v-file-input @change="change_adjunto" accept="image/*" label="Adjuntar imagen" v-model="setreg.adjunto"
                    class="icon-right"></v-file-input>
                </v-col>
                <v-col sm="12" md="4">
                  <v-btn v-if="setreg.adjunto_dowload != null" class="ma-2" color="primary"
                    @click="dowload_image(URL_SPACE + '/' + setreg.adjunto_dowload)" target="_blank" :loading="loading"
                    :disabled="loading">
                    Descargar Imagen Adjuntada
                  </v-btn>
                </v-col>

              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer />
          <ButtonComp normalButton @click="guardarAnecdotico()"
            :textButton="setreg.id != 0 ? 'Guardar Cambios' : 'Guardar'" iconBut="fas fa-save" />
        </template>
      </ComunDialogComp>

    </v-form>


    <ComunDialogComp v-model="dialog_detail" maxWidth="1000" :title="setreg.title" @close-modal="dialog_detail = false">
      <template v-slot:title>
        <v-chip label dark color="success"> {{ setreg.title }} </v-chip>
      </template>
      <template v-slot:body>
        <v-row>
          <v-col cols="12" md="8">
            <TextfieldComp textLabel="Estudiante" item-text="view_alumno" v-model="setreg.alumno" readonly />
          </v-col>
          <v-col cols="12" md="4">
            <TextfieldComp textLabel="Fecha de registro de anécdota" item-text="view_fecha" v-model="setreg.fecha"
              readonly />
          </v-col>

          <v-col cols="12" md="4">
            <TextfieldComp textLabel="Hora" item-text="view_hora" v-model="setreg.hora" readonly />
          </v-col>

          <v-col cols="12" md="4">
            <TextfieldComp textLabel="Lugar del suceso" maxlength="80" v-model="setreg.lugar" readonly />
          </v-col>

          <v-col cols="12" md="4">
            <TextfieldComp textLabel="Docente" item-text="desc_docente" v-model="setreg.docente" readonly />
          </v-col>
          <!-- -->
          <v-col cols="12" md="6">
            <TextfieldComp name="input-7-4" textArea textLabel="Descripción / Comentario" v-model="setreg.descripcion"
              readonly />

          </v-col>

          <v-col cols="12" md="6">
            <TextfieldComp name="input-7-4" textArea textLabel="Análisis / Interpretación" v-model="setreg.analisis"
              readonly />
          </v-col>

          <v-col cols="12">
            <v-btn v-if="setreg.adjunto_dowload != null" class="ma-2" color="primary"
              @click="dowload_image(URL_SPACE + '/' + setreg.adjunto_dowload)" target="_blank" :loading="loading"
              :disabled="loading">
              Descargar imagen Adjuntada
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </ComunDialogComp>


    <!-- show dialog detail modal -->



    <ComunDialogComp v-model="confirm_modal" Confirmdialog @close-modal="confirm_modal = false"
      @confirm-item="crear_registro()" titleWindow="Guardar registro" @cancel-item="confirm_modal = false">
      <template v-slot:body>
        <span class="font-font-weight-bold text-center">
          ¿Desea guardar esta anécdota al estudiante?
        </span>
      </template>
    </ComunDialogComp>

    <ComunDialogComp Deletedialog v-model="confirm_delete" @close-modal="confirm_delete = false"
      @cancel-item="confirm_delete = false" titleWindow="Eliminar registro" @delete-item="deleteItem()">
      <template v-slot:body>
        ¿Está seguro de eliminar este registro ?
      </template>
    </ComunDialogComp>


    <!-- list historial -->
    <!-- show dialog modal -->
    <ComunDialogComp v-model="dialog_history" maxWidth="1000" @close-modal="dialog_history = false">
      <template v-slot:title>
        Seguimiento de anécdotas
        <v-chip label class="ml-2" color="green white--text accent-3"> {{ history.title }} </v-chip>
      </template>
      <template v-slot:body>
        <v-row class="mx-0 px-3 pt-4" justify="center">
          <v-col cols="5" class="d-grid-use align-end text-left">
            <p class="mb-0">Estudiante</p>
            <p class="d-block font-weight-bold border-bottom">
              {{ history.alumno }}
            </p>
          </v-col>

          <v-col cols="7" class="mb-2">
            <v-timeline align-bottom dense timeline-inner-dot-regular-size>
              <v-timeline-item v-for="(item, i) in history.data" :key="i" color="#000" right dense fill-dot small
                class="align-end">
                <v-card class="mx-auto" max-width="344">
                  <v-card-text class="font-weight-bold">
                    <div class="d-flex justify-space-between">
                      <span> Fecha: {{ item.fecha }}</span>
                      <span> Hora: {{ item.hora }}</span>
                    </div>
                    <p class="mb-0">Docente encargado: {{ item.nombres }}</p>
                    <p class="mb-0">Descripción / Comentario</p>
                    <div class="border px-1 py-1">
                      {{ item.descripcion_evento }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </v-row>
      </template>
    </ComunDialogComp>


    <!-- listar registros -->
    <v-row>

    </v-row>
  </div>
</template>
<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import { BUCKET_ORIGIN_SPACE } from '../../helpers/axios';
import { RegistoAnecdoticoHeaders } from '../../helpers/headersTable'
import ButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../components/ComponentsEst/ComunDialogComp.vue';
import ComundataTablecomp from '../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from '../../components/ComponentsEst/AutocompleteComp.vue';
import TextfieldComp from '../../components/ComponentsEst/textfieldComp.vue';

export default {
  name: "registroanecdotico",
  components: {
    ButtonComp,
    AutocompleteComp,
    ComunDialogComp,
    ComundataTablecomp,
    TextfieldComp
  },
  data() {
    return {
      //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
      paramComponente: { id_modulo: 8, id_submodulo: 80 }, //sud_modulo y modulo
      datoLogin: sessionStorage, // variables de sesion del usuario
      ////////////////////////////////////////////////////////
      //form validate
      RegistoAnecdoticoHeaders,
      rules: {
        required: (value) => !!value || "Campo requerido",
        selectReq: (value) =>
          !!value || "Debe seleccionar un campo de la lista",
      },

      loading: false,
      menu: false,
      time: new Date().getHours() + ":" + new Date().getMinutes(),
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      //alert
      mensaje: false,
      text: "",
      // create
      dialog: false,
      dialog_detail: false,
      dialog_history: false,
      history: {
        title: "",
        alumno: "",
        data: [],
      },
      // set & get data
      setreg: {
        id: 0,
        title: "",
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_usu: sessionStorage.id,
        docente: sessionStorage.nombre_persona,
        id_usu_mod: 0,
        id_alumno: 0,
        id_nivel: 0,
        id_grado: 0,
        id_seccion: 0,
        fecha_evento: "",
        hora_evento: "",
        lugar_evento: "",
        descripcion_evento: "",
        analisis_evento: "",
        adjunto: null,
        old_adjunto: null,
        adjunto_dowload: null,
        id_persona: sessionStorage.id_persona,
        desc_perfil: sessionStorage.descripcion_perfil,
      },
      confirm_delete: false,
      confirm_modal: false,

      confirm: {
        id: 0,
        show: false,
        type: 0,
        title: "",
      },

      //Dias habiles
      allowedDaysR: [],

      // header datatables


      filter: {
        id_nivel: 0,
        id_grado: 0,
        id_seccion: 0,
        alumno: "",
        GradosAdmin: [],
        SeccionGrado: [],
      },
      // data registros
      desserts: [],

      // filter parameters
      parametros: {
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_colegio_adm_nivel: sessionStorage.id_colegio,
        id_persona: sessionStorage.id_persona,
        is_docente: false,
      },
      extralumno: {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_seccion: 0,
      },
      paramsProfesor: {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_profesor: 0,
      },

      parametrosuser: {
        usu_usuario: sessionStorage.usu_usuario,
      },
      base_url: `${API_URL}`,
      URL_SPACE: BUCKET_ORIGIN_SPACE,
      // data
      NivelesAdmin: [],
      GradosAdmin: [],
      SeccionGrado: [],
      Profesores: [],
      Alumnos: [],
      Allistareg: [],
    };
  },

  mounted() {
    /* this.get_perfil()
      this.getAllNivelesAdmin(); */
    this.resetForm();
    // this.getAllProfesores()
    //his.listareganec();
    this.$store.dispatch('getAlldiasEscolares').then(() => {
      this.allowedDaysR = this.diasEscolaresColegio;
    })

  },
  created() {
    this.clear();
    this.get_perfil();
    this.getAllNivelesAdmin();
    this.initializeData();
    this.actualizarParamentro();
    this.docente = sessionStorage.nombre_persona;
    this.desc_perfil = sessionStorage.descripcion_perfil
  },


  computed: {
    //Llamar al estado que tiene los dias habiles
    ...mapState(["diasEscolaresColegio"]),
    ...mapGetters("login", ["componenteEvento"]),

    computedDateFormatted2() {

      return this.formatDate(this.setreg.fecha_evento)
    },
    RegAnecdoticoAvailablePerfils() {
      if (this.desc_perfil == 'Docente' || this.desc_perfil == 'Coordinador' || this.desc_perfil == 'Administrador del sitio web / Webmaster' || this.desc_perfil == 'Director') {
        return true
      } else {
        return false
      }
    },
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations({ 
      setEnviarMens: "mensajeSis/setEnviarMens",
    }),
    ////////////////////////////////////////////////////////

    ...mapActions("nivelesGrados", [
      "getAllGrados",
      //'getAllNiveles'
    ]),

    usuario() {
      return sessionStorage;
    },

    formatter: date => {
      const [day, month, year] = date.split('/');
      return parseInt(`${year}${month}${day}`);
    },
    create() {
      this.resetForm();
      this.clear();
      this.dialog = true;
      this.setreg.title = "Crear registro anecdótico";
      this.get_date();
    },
    clear() {
      this.setreg.title = "";
      this.setreg.id_colegio = sessionStorage.id_colegio;
      this.setreg.id_ano_lectivo = sessionStorage.id_ano_lectivo;
      this.setreg.id_persona = sessionStorage.id_persona;
      this.setreg.docente = sessionStorage.nombre_persona;
      this.setreg.id_usu = sessionStorage.id;
      this.setreg.id_alumno = 0;
      this.setreg.id_nivel = 0;
      this.setreg.id_grado = 0;
      this.setreg.id_seccion = 0;
      this.setreg.fecha_evento = "";
      this.setreg.hora_evento = "";
      this.setreg.lugar_evento = "";
      this.setreg.descripcion_evento = "";
      this.setreg.analisis_evento = "";
      this.setreg.adjunto = null;
      this.setreg.old_adjunto = null;
      this.setreg.adjunto_dowload = null;
      this.setreg.id = 0;
      this.confirm.id = 0;
      this.confirm.type = 0;

      this.GradosAdmin = []
      this.SeccionGrado = []
      this.Profesores = []
      this.Alumnos = []
    },

    resetForm() {
      if (this.$refs.formDatos != undefined) {
        this.$refs.formDatos.resetValidation();
      }
    },


    async get_perfil() {
      try {
        let response = await axios.get(
          `/administrativo/personal/getPersonalPerfil/${this.parametros.id_persona}`
        );
        if (response.data != null) {
          this.parametros.is_docente =
            response.data.es_profesor == 1 ? true : false;
        } else {
          this.parametros.is_docente = false;
        }
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },
    get_date() {
      this.time = new Date().getHours() + ":" + new Date().getMinutes();
      this.date = new Date().toISOString().substr(0, 10);
    },

    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },


    change_date() {
      let now = new Date().toISOString().substr(0, 10);
      if (this.setreg.fecha_evento && this.setreg.fecha_evento == now) {
        this.time = new Date().getHours() + ":" + new Date().getMinutes();
        this.setreg.hora_evento = "";
      } else {
        this.time = null;
        this.setreg.hora_evento = "";
      }
    },
    // init data
    async initializeData() {
      this.setreg.id = 0;
      try {
        let response = await axios.post("/evaluacion/anecdoticos/all", {
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_nivel: this.filter.id_nivel,
          id_grado: this.filter.id_grado,
          id_seccion: this.filter.id_seccion,
          alumno: this.filter.alumno,
        });
        let data = [];
        response.data.forEach((element) => {
          if (data[element.id_alumno] == undefined) {
            let time = element.hora.split(":");
            element.hora = time[0] + ":" + time[1];
            data[element.id_alumno] = element;
          }
        });
        data.sort(function (a, b) {
          if (a.id > b.id) {
            return -1;
          }
          if (a.id < b.id) {
            return 1;
          }
          return 0;
        });

        this.desserts = data;
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },
    // obtener niveles
    // eslint-disable-next-line no-unused-vars
    async getAllNivelesAdmin(type = false) {
      let params = this.parametros;
      try {
        let response = await axios.post(
          "/administrativo/nivel/niveladmin/",
          params
        );
        this.NivelesAdmin = response.data;
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },
    // obtener grados por nivel
    async getAllGradosAdmin(id, type = false) {
      this.setreg.id_alumno = 0;
      this.setreg.id_grado = 0;
      this.setreg.id_seccion = 0;

      // limpiar data
      this.GradosAdmin = []
      this.SeccionGrado = []
      this.Profesores = []
      this.Alumnos = []
      try {
        let response = await axios.post(
          "/administrativo/grado/gradosNivelAdmin/",
          {
            id_nivel: id,
            id_colegio: this.extralumno.id_colegio,
            id_ano_lectivo: this.extralumno.id_ano_lectivo,
          }
        );
        if (type) {
          this.filter.id_nivel = id;
          this.filter.GradosAdmin = response.data;
          setTimeout(() => {
            this.initializeData();
          }, 150);
        } else {
          this.GradosAdmin = response.data;
        }
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },
    // secciones por grados
    async getAllSeccionesGrados(id, type = false) {
      this.setreg.id_alumno = 0;
      this.setreg.id_seccion = 0;

      this.SeccionGrado = []
      this.Profesores = []
      this.Alumnos = []
      try {
        let response = await axios.post(
          "/administrativo/seccion/seccionGrado",
          {
            id_grado: id,
            id_colegio: this.extralumno.id_colegio,
            id_ano_lectivo: this.extralumno.id_ano_lectivo,
          }
        );
        if (type) {
          this.filter.id_grado = id;
          this.filter.SeccionGrado = response.data;
          setTimeout(() => {
            this.initializeData();
          }, 150);
        } else {
          this.SeccionGrado = response.data;
        }
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },
    seccion_filter() {
      setTimeout(() => {
        this.initializeData();
      }, 150);
    },
    alumno_filter() {
      if (this.filter) {
        setTimeout(() => {
          this.initializeData();
        }, 150);
      }
    },
    //----------secciones por seccion  ------------
    async alumnos(id) {
      this.setreg.id_alumno = 0;

      this.Alumnos = []
      try {
        this.extralumno.id_seccion = id;
        let response = await axios.post(
          "/administrativo/seccion/secalu/fil/",
          this.extralumno
        );
        this.Alumnos = response.data;
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },

    active_dialog_detail() {
      this.dialog_detail = !this.dialog_detail;
    },
    // obtener docente
    async get_docente(item) {
      try {
        let response = await axios.post(
          `/evaluacion/anecdoticos/docente/${item.id_persona}`,
          {
            id_colegio: this.extralumno.id_colegio,
            id_ano_lectivo: this.extralumno.id_ano_lectivo,
          }
        );
        const { data } = response;
        this.setreg.docente = data.nombres;
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },

    async dowload_image(url) {
      this.loading = true;
      
      try {
        await this.$Files['downloadFetch']({ url });
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      } finally {
        this.loading = false;
      }
    },
    /// ------------- ver detalle - visualiar
    async viewDetail(item) {
      this.clear();
      this.get_docente(item);
      //const res = await this.get_image(item);

      this.setreg.title = `Nivel: ${item.nivel} | Grado: ${item.grado} | Seccion: ${item.seccion}`;
      this.setreg.alumno = item.nombres;
      this.setreg.nivel = item.nivel;
      this.setreg.grado = item.grado;
      this.setreg.seccion = item.seccion;
      this.setreg.fecha = item.fecha;
      this.setreg.hora = item.hora;
      this.setreg.lugar = item.lugar_evento;
      this.setreg.docente = "docente";
      this.setreg.descripcion = item.descripcion_evento;
      this.setreg.analisis = item.analisis_evento;

      this.setreg.adjunto_dowload = item.adjunto ? item.adjunto : null;
      this.setreg.adjunto = this.get_adjunto(item);
      setTimeout(() => {
        this.active_dialog_detail();
      }, 100);
    },
    active_history(item) {
      this.dialog_history = true;
      this.history.title = `Nivel: ${item.nivel} Grado: ${item.grado} Seccion: ${item.seccion}`;
      this.history.alumno = item.nombres;
      this.get_history(item);
    },
    async get_history(item) {
      try {
        let response = await axios.post(
          `/evaluacion/anecdoticos/alumno/${item.id_alumno}`,
          {
            id_colegio: this.extralumno.id_colegio,
            id_ano_lectivo: this.extralumno.id_ano_lectivo,
          }
        );
        this.history.data = response.data;

      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },

    change_adjunto() {
      // this.setreg.adjunto = "1241696876219634.jpg"
    },

    get_adjunto(item) {
      if (item.adjunto) {
        let file_url = `${this.base_url}recurso/colegio/adjunto/${this.extralumno.id_colegio}/${item.adjunto}`;
        return new File(["adjunto"], file_url, {
          type: "image/*",
        });
      } else {
        return null;
      }
    },
    // obtener registro por id
    async getAnecdotico(item) {
      this.clear();
      this.update = true;
      this.setreg.title = "Editar registro anecdótico";
      try {
        let response = await axios.post(
          `evaluacion/anecdoticos/all/${item.id}`,
          {
            id_nivel: item.id_nivel,
            id_colegio: this.extralumno.id_colegio,
            id_ano_lectivo: this.extralumno.id_ano_lectivo,
          }
        );
        const { data } = response;
        if (data) {
          this.get_docente(data);
          this.getAllGradosAdmin(data.id_nivel);
          this.getAllSeccionesGrados(data.id_grado);
          this.alumnos(data.id_seccion);

          this.setreg.id = item.id;
          this.setreg.old_adjunto = data.adjunto;
          this.setreg.id_colegio = data.id_colegio;
          this.setreg.id_ano_lectivo = data.id_ano_lectivo;
          this.setreg.id_usu = data.id_persona;
          //this.setreg.id_usu = data.id_usu_ing;
          //this.setreg.id_usu_mod = data.id_usu_mod;
          this.setreg.id_alumno = data.id_alumno;
          this.setreg.id_nivel = data.id_nivel;
          this.setreg.id_grado = data.id_grado;
          this.setreg.id_seccion = data.id_seccion;
          this.setreg.fecha_evento = data.fecha_evento;

          let time = data.hora_evento.split(":");
          this.setreg.hora_evento = time[0] + ":" + time[1];
          this.setreg.lugar_evento = data.lugar_evento;
          this.setreg.descripcion_evento = data.descripcion_evento;
          this.setreg.analisis_evento = data.analisis_evento;
          this.setreg.adjunto_dowload = data.adjunto ? data.adjunto : null;
          this.setreg.adjunto_dowload = data.adjunto ? data.adjunto : null;
          this.setreg.adjunto = this.get_adjunto(data);
        }

        setTimeout(() => {
          this.dialog = true;
        }, 100);
      } catch (error) {
        console.error(error);
        this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
      }
    },
    // udpate data
    udpateAnecdotico(item) {
      this.getAnecdotico(item);
    },
    // crear registro
    async crear_registro() {
      let params = this.setreg;
      const response = await axios.post("/evaluacion/anecdoticos", params);
      this.confirm_modal = false
      this.dialog = false;
      const { data: res } = response;
      if (this.setreg.adjunto && res) {
        this.subir_adjunto(res);
      } else {
        this.clear();
        this.initializeData();
        if (res.success) {
          this.setEnviarMens({
            tipo: "S",
            mensaje: res.message,
            tiempo: null,
          });
        } else {
          this.setEnviarMens({
            tipo: "E",
            mensaje: res.message,
            tiempo: null,
          });
        }
      }
    },
    async subir_adjunto(element) {
      const { data: item } = element;

      if (this.setreg == null) {
        return this.setEnviarMens({
          tipo: "S",
          mensaje: element.message
            ? element.message
            : "¡Información creada con éxito!",
          tiempo: null,
        });
      }
      let formData = new FormData();
      formData.append("subirArchivo", this.setreg.adjunto);
      formData.append("id_colegio", item.id_colegio);
      formData.append("id_usu", sessionStorage.id);
      formData.append("id", item.id);
      formData.append("old_name", this.setreg.old_adjunto);

      await axios.post("archivo/anecdotico", formData)
        .then((res) => {
          const { data: response } = res;
          if (response.success) {
            this.setEnviarMens({
              tipo: "S",
              mensaje: res.data
                ? res.data.message
                : "¡Información creada con éxito!",
              tiempo: null,
            });
            this.initializeData();
            setTimeout(() => {
              this.clear();
            }, 200);
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: `Error en Subir Imagen`,
              tiempo: null,
            });
          }
        })
        .catch(function (e) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error en Subir Imagen`+e,
            tiempo: null,
          });
        });
    },
    // actualizar registro
    actualizar_registro() {
      let params = { ...this.setreg };
      if (params.old_adjunto != params.adjunto) {
        params.adjunto = "";
      }

      axios
        .put(`/evaluacion/anecdoticos/${this.setreg.id}`, params)
        .then((response) => {
          const { data: res } = response;

          if (res.success) {
            if (
              res.success == true &&
              this.setreg.adjunto != "" &&
              this.setreg.adjunto != null
            ) {
              if (
                this.setreg.adjunto != null &&
                this.setreg.old_adjunto != this.setreg.adjunto.name
              ) {
                this.subir_adjunto(res);
              } else {
                this.setEnviarMens({
                  tipo: "S",
                  mensaje: res.message,
                  tiempo: null,
                });
              }
            } else {
              this.setEnviarMens({
                tipo: "S",
                mensaje: res.message,
                tiempo: null,
              });
            }
            this.confirm.show = false;
            this.dialog = false;
            this.initializeData();
            setTimeout(() => {
              this.clear();
            }, 1000);
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: res.message,
              tiempo: null,
            });
          }
        })
        .catch(() => {
          this.setEnviarMens({
            tipo: "E",
            mensaje: "ocurrio error al actualizar",
            tiempo: null,
          });
        });
    },
    // guardar anectodico
    guardarAnecdotico() {
      if (this.$refs.formDatos.validate()) {
        if (this.setreg.id != 0) {
          this.actualizar_registro();
        } else {
          this.dialog_save(0, true);
        }
        //this.setreg.id = 0;
      }
    },
    // confirmacion de registro
    dialog_save(id) {
      this.confirm_modal = true
      this.confirm.id = id != 0 || id != "" ? id : 0;
      this.confirm.type = 2;
    },

    dialog_delete(item) {
      this.confirm_delete = true;
      this.confirm.id = item.id;
      
    },

    deleteItem() {
      axios
        .delete(`/evaluacion/anecdoticos/${this.confirm.id}`)
        .then((response) => {
          this.confirm_delete = false;
      
          this.clear();
          this.initializeData();
          if (response.data.success) {
            this.setEnviarMens({
              tipo: "S",
              mensaje: response.data.message,
              tiempo: null,
            });
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: response.data.message,
              tiempo: null,
            });
          }



        })
        .catch((error) => {
          console.error(error);
          this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
        });
    },

    allowedDays: function (date) {
      return this.allowedDaysR.includes(date);
    }
  },
  watch: {
    dialog: function () {
      if (this.dialog) {
        this.resetForm();
      }
    },
  },

};
</script>

<style scoped>
.v-data-table.fluid {
  width: 100% !important;
}

.custom-head {
  background: rgb(204, 203, 203);
}

.d-grid-use {
  display: grid !important;
  align-content: flex-end !important;
  grid-row-gap: 0;
}

.border-bottom {
  border-bottom: 1px solid gray;
}

.w-100,
.card-detail .v-toolbar__content {
  width: 100% !important;
}

table thead tr th {
  font-weight: 700;
  font-size: 16px !important;
  height: auto !important;
}

table thead tr {
  padding: 10px;
}

.p-0 {
  padding: 0px;
}

.row {
  margin: 0px;
}

.border {
  border: 1px solid rgba(0, 0, 0, 0.42);
}

.btn-close {
  width: 40px;
  min-width: 40px !important;
  padding: 0px !important;
  height: 40px !important;
  line-height: 40px;
  border-radius: 50%;
  overflow: hidden;
  text-align: center;
  color: white;
}

.btn-close span,
.btn-close span i {
  margin: 0px !important;
  text-align: center;
}

body {
  background: #dbdbdb;
  font-family: "Open sans";
}
</style>